import { BodyXS, Box, CloseIcon, BodyMedium } from '@parspec/pixel';

interface CardProps {
    title: string;
    count: string | number;
    helperText?: number | string;
    helperTextColor?: string;
    showIcon?: boolean;
    titleColor?: string;
    countColor?: string;
    minCardWidth?: number
}

const defaultColor = 'success.main';

const StatsCard = (props: CardProps) => {
    const { title, count, helperText, helperTextColor, showIcon, titleColor, countColor, minCardWidth = 160 } = props;
    return (
        <Box display="flex" gap={1} mt={1} alignItems="baseline" px={{ md: 1, lg: 3 }} minWidth={minCardWidth} flexWrap='wrap'>
            <Box display="flex" alignItems="center" gap={1.5} justifyContent="space-between">
                <BodyMedium fontWeight='700' color={countColor || 'secondary.contrastText'}>{count}</BodyMedium>

                {helperText && (
                    <>
                        <BodyMedium sx={{ fontWeight: 'lighter' }} color={countColor || 'secondary.contrastText'}>
                            {'|'}
                        </BodyMedium>
                        <BodyMedium fontWeight='700' color={helperTextColor || defaultColor}>{helperText}</BodyMedium>
                    </>
                )}
            </Box>
            <Box display="flex" alignItems="center" mt={{ lg: -1, sm: 0 }}>
                <BodyXS fontWeight='600' color={titleColor || 'white'} sx={{ textTransform: 'uppercase' }}>
                    {title}
                </BodyXS>
                {showIcon && <CloseIcon sx={{ fontSize: '12px' }} />}
            </Box>
        </Box>
    );
};

StatsCard.defaultProps = {
    showIcon: false
};

export default StatsCard;
